$(function(){
  $(document).on('click','.u_cart_drawer_close,.overlay-close-clipping,.u_pickup_close',function(){
    console.log('yes')
    $('html').removeClass('m6pn-open')
    $('aside.m6pn').removeClass('toggle')
        $('html').removeClass('u_hold')
  })
    $(document).on('click','.u_header_cart,.overlay-tertiary',function(){
    console.log('yesr3')
    $('html').addClass('u_hold')
  })
            $(document).on('click','.u_accordian_notr_head',function(){               
            $('.u_accordian_note_body').slideToggle();
            $('.u_note_icon').toggleClass('up_arrow');
            })
          
   $(document).on('click','.u_hamberger,.u_mb_menu_header_close',function(){
    $('.u_mobile_menu').toggleClass('active');
    $('html').toggleClass('overflow');     
  });
   $('.u_icon_mb').click(function(){
    $(this).find('i').toggleClass(' fa-minus fa-plus');
    $(this).closest('.u_dropdown_list_mb').find('.u_sec_dropdown_mb').slideToggle();
  })
   $('.u_sicon_mb').click(function(){
  $(this).find('i').toggleClass(' fa-minus fa-plus');
    $(this).closest('.u_dropdown_list_mb').find('.u_third_dropdown_mb').slideToggle();
  })
})